import Vue from 'vue';
import UBLogo from '@/components/UBLogo/UBLogo.vue';
import { createStore } from "../../store";
import PageNav from '@/components/page-nav/PageNav.vue';
import CookieCompliance from "@/components/CookieCompliance/CookieCompliance.vue";
var VueScrollTo = require('vue-scrollto');
var TweenMax = require("TweenMax");
//@ts-ignore
import TimelineMax from 'gsap/src/uncompressed/TimelineMax.js';
var EasePack = require("EasePack");
export default Vue.extend({
    name: 'app',
    store: createStore(),
    components: {
        'ub-logo': UBLogo,
        'page-nav': PageNav,
        CookieCompliance
    },
    directives: {
        'scroll-to': VueScrollTo,
    },
    data() {
        return {
            navToggled: false,
            fadeInAnimationTl: null,
            contentWrapper: false,
        };
    },
    mounted() {
        setTimeout(() => {
            this.initNavAnimation();
        }, 200);
        document.addEventListener("touchstart", function () {
        }, true);
        setTimeout(function () {
            var a = document.createElement("script");
            var b = document.getElementsByTagName('script')[0];
            a.src = document.location.protocol + "//dnn506yrbagrg.cloudfront.net/pages/scripts/0011/6939.js";
            a.async = true;
            a.type = "text/javascript";
            b.parentNode.insertBefore(a, b);
        }, 1);
    },
    computed: {
        currentCategory() {
            return this.$store.getters.currentCategory;
        },
        routeKey() {
            return this.$route.name;
        },
        isWorksPage() {
            return this.$route.path.includes('/arbeiten/');
        }
    },
    watch: {
        '$route'(to, from) {
            this.scrollToTop();
            if (this.navToggled) {
                this.navToggled = false;
                this.fadeInAnimationTl.reverse(0).timeScale(4);
            }
            let mainWrapper = document.getElementById('main_wrapper');
            if (mainWrapper) {
                mainWrapper.style.perspective = '1080px';
                setTimeout(() => {
                    mainWrapper.style = '';
                }, 1000);
            }
            let footer = document.querySelector('footer');
            if (footer) {
                footer.style.display = 'none';
                setTimeout(() => {
                    footer.style = '';
                }, 1000);
            }
        },
    },
    methods: {
        goToBlogIndex() {
            this.$router.push({ name: 'Blog' });
            this.$store.commit('setCurrentCategory', null);
        },
        scrollToTop() {
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': 0
            });
        },
        toggleNav() {
            if (this.navToggled === false) {
                this.navToggled = true;
                this.fadeInAnimationTl.play().timeScale(1.5);
            }
            else {
                this.navToggled = false;
                this.fadeInAnimationTl.reverse(0).timeScale(4);
            }
        },
        isCurrentRoute(route) {
            return this.$route.matched[0] && (route.filter((item) => {
                return item === this.$route.matched[0].name;
            }).length);
        },
        initNavAnimation() {
            // Timelines
            this.fadeInAnimationTl = new TimelineMax();
            this.fadeInAnimationTl
                .to('.subnavigation', 0.1, {
                autoAlpha: 1,
            }, 0)
                .to('.subnavigation', 0.5, {
                y: 0,
                ease: EasePack.Power3.ease
            }, 0)
                .fromTo('.menu_logo', 1, {
                autoAlpha: 0,
                y: -20
            }, {
                autoAlpha: 1,
                y: 0,
                ease: EasePack.Power1.easeOut
            }, 0)
                .fromTo('.subnavigation .nav-title', 0.5, {
                y: -20,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha: 1,
                ease: EasePack.Power1.ease
            }, 0.2, 0)
                .staggerFromTo('.subnavigation .location-1 h5, .subnavigation .location-1 p', 0.5, {
                y: -10,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha: 1,
                ease: EasePack.Power1.ease
            }, 0.3, 0.2)
                .staggerFromTo('.subnavigation .location-2 h5, .subnavigation .location-2 p', 0.5, {
                y: -10,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha: 1,
                ease: EasePack.Power1.ease
            }, 0.3, 0.2)
                // lines draw in
                .staggerFromTo('.subnavigation .menu li', 0.7, {
                y: -20,
                autoAlpha: 0
            }, {
                y: 0,
                autoAlpha: 1,
                ease: EasePack.Power1.ease
            }, 0.1, 0.2).stop();
        }
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/layouts/Base/Base.ts
// module id = null
// module chunks = 